import { apiClient } from "@/api/api-client";
import createBaseService, { type Pagination } from "@/api/base-service.ts";
import type { CaseHearing } from "@/features/case-evaluation/types/activities";
import type { Event } from "../../types/event";

const eventService = {
	...createBaseService<Event>("/events"),

	listByRange: async (params = {}) => {
		const response = await apiClient.get<{ data: Event[]; meta: Pagination }>("/events-dashboard", { params });

		return response.data;
	},
	validateHolidays: async (due_date: string) => {
		const response = await apiClient.post<{ data: Event }>("/events/validate_holiday", {
			due_date,
		});
		return response.data.data;
	},
	validateHearing: async (due_date: string, caseRecordId: string) => {
		const response = await apiClient.post<{ data: number }>(`/events/${caseRecordId}/validate_hearings`, {
			due_date,
		});
		return response.data;
	},
	validateHearingDateByCalendarId: async (due_date: string, calendarId: string) => {
		const response = await apiClient.post<{ data: number }>(`/events/${calendarId}/validate_hearings_calendarId`, {
			due_date,
			calendarId,
		});
		return response.data;
	},
	addHearing: async (data: CaseHearing) => {
		const response = await apiClient.post<{ data: CaseHearing }>("/events/add-case-hearing-calendar", data);

		return response.data.data;
	},
	addEvents: async (data: CaseHearing) => {
		const response = await apiClient.post<{ data: CaseHearing }>("/events/add-case-events-calendar", data);

		return response.data.data;
	},
	preview: async (params = {}): Promise<Blob> => {
		const response = await apiClient.post("/events/case-schedule-download", params, {
			responseType: "blob",
		});

		return new Blob([response.data], { type: "application/pdf" });
	},
	deleteManualEvents: async (id: string) => {
		const response = await apiClient.delete<{ data: Event }>(`/events/${id}/delete-manual-event`, {});
		return response.data.data;
	},

	updateManualEvents: async (data: { id: string; title: string; start_at: string; end_at: string }) => {
		const response = await apiClient.put<{ data: Event }>(`/events/${data.id}/edit-manual-event`, data);

		return response.data.data;
	},
};

export default eventService;
